export default __webpack_public_path__ + "static/media/team3.9c30b65c.png";